import { isEqual } from "lodash";
import { useState } from "react";

export function useDeepUnchanged<T>(array: T[]): T[] {
    const [ cachedArray, setCachedArray ] = useState(array);

    let retArray = cachedArray;
    if(!isEqual(cachedArray, array)) {
        setCachedArray(array);
        retArray = array;
    }

    return retArray;
}